import React from "react";

import { Row, Col, Container } from "react-bootstrap";
import { IoIosArrowForward } from "react-icons/io";

import { PALETTE } from "../../common/ThemeConstants";
import { AdminTabsList } from "../../admin/constants";
import Failed from "../../loading/pages/Failed";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/hook";
import DatabaseHeader from "../components/DatabaseHeader";
import ContainerResponsive from "../../common/components/ContainerResponsive";

export default function Database() {
  const auth = useAuth();
  const user = auth.user;
  const role = auth.role;
  return (
    <>
      <DatabaseHeader />
      <ContainerResponsive>
        {role !== "Admin" ? (
          <div>
            <Failed />
          </div>
        ) : (
          <Container className="text-center">
            {AdminTabsList.map((tab, idx) => (
              <Link
                key={idx}
                to={tab.to}
                className="text-center"
                style={{ textDecoration: "none" }}
              >
                <Row
                  className="py-3 shadow-sm rounded-md my-3 m-auto"
                  style={{ width: "100%" }}
                >
                  <Col
                    xs={2}
                    className="align-self-center text-center"
                    style={{ color: PALETTE.DARKGRAY }}
                  >
                    <img
                      src={tab.icon}
                      alt={tab.name}
                      style={{ width: "2rem" }}
                    />
                  </Col>
                  <Col
                    xs={8}
                    className="text-start align-self-center"
                    style={{ color: PALETTE.DARKGRAY }}
                  >
                    {tab.name}
                  </Col>
                  <Col xs={2} className="align-self-center text-end">
                    <span className="m-auto">
                      <IoIosArrowForward color={PALETTE.GRAY} />
                    </span>
                  </Col>
                </Row>
              </Link>
            ))}
          </Container>
        )}
      </ContainerResponsive>
    </>
  );
}
